import React from 'react';
import { getCurrencyByDomain } from '@/utils/domain';
import { useCurrencyStore } from '@/store/currency';
import Link from '../../Link';
import '../index.css';

export function SingleTestPricing() {
  const currencyStore = useCurrencyStore();
  function formatPrice(price: number, currency: string): string {
    if (currency === `CAD`) {
      const formattedPriceInCAD = Math.round(price * 1.4);
      return `${formattedPriceInCAD} CAD`; // Round to the nearest whole number
    }
    const formattedPriceInUSD = Math.round(price); // Round to the nearest whole number
    return `${formattedPriceInUSD} `; // Default to USD
  }

  const domain = typeof window !== `undefined` ? window.location.hostname : ``;
  const selectedCurrency = getCurrencyByDomain(domain);

  const stripeLinkUSD = process.env.GATSBY_USD_SINGLE_GUT_STRIPE_URL;
  const stripeLinkCAD = process.env.GATSBY_CAD_SINGLE_GUT_STRIPE_URL;

  return (
    <div className="w-full md:p-[24px] p-8 h-full md:mt[40px] slg:mt-0 md:pt-[48px]">
      <div className="flex flex-col gap-y-[23px]">
        <div>
          <img src="/images/gut-scan-test.svg" alt="" className="w-full" />
        </div>
        <div>
          <div className="flex flex-col">
            <h3 className="text-xl font-medium text-navy-blue">
              GutScan (single test)
            </h3>
            <span className="italic text-[#A3A1A8] font-medium mt-3">
              Practitioners & non-practitioners
            </span>
          </div>
          <div className="flex flex-col gap-y-5">
            <p className="text-base font-medium text-navy-blue mt-5">
              16S-based gut microbiome test
            </p>
            <div>
              {currencyStore.currency === `US$` ? (
                <span className="text-2xl font-bold text-primary">
                  US${formatPrice(199, selectedCurrency)}
                </span>
              ) : (
                <span className="text-2xl font-bold text-primary">
                  CA${formatPrice(275, selectedCurrency)}
                </span>
              )}
              {/* <p className="text-base text-[#A3A1A8] font-medium mt-2">
                Save <strong>$30</strong> with July 4th Sale! Use discount code
                <span className="font-bold text-primary"> INDEPENDENCE30 </span>
                at checkout.
              </p> */}
            </div>
          </div>
        </div>
        {domain.includes(`.ca`) ||
        domain.includes(`vitract-ca.netlify.app/pricing/`) ? (
          <Link href={stripeLinkCAD}>
            <button
              type="button"
              className="mt-auto slg:mt-[81px] xl:mt-[33.5px] w-full border border-navy-blue border-solid rounded text-navy-blue hover:bg-navy-blue hover:text-white py-3 text-base font-medium"
            >
              Order Now
            </button>
          </Link>
        ) : (
          <Link href={stripeLinkUSD}>
            <button
              type="button"
              className="mt-auto slg:mt-[81px] xl:mt-[33.5px] w-full border border-navy-blue border-solid rounded text-navy-blue hover:bg-navy-blue hover:text-white py-3 text-base font-medium"
            >
              Order Now
            </button>
          </Link>
        )}
      </div>
    </div>
  );
}
